import { gql } from "@apollo/client";
import WorkerFields from "../fragments/worker-fragment";

export default gql`
  mutation unsuspendWorker($data: WorkerReasonInput!) {
    unsuspendWorker(data: $data) {
      ...WorkerFields
    }
  }
  ${WorkerFields}
`;
